import { render, staticRenderFns } from "./CiCampgroundInfo.vue?vue&type=template&id=15a36ac2&scoped=true"
import script from "./CiCampgroundInfo.vue?vue&type=script&lang=js"
export * from "./CiCampgroundInfo.vue?vue&type=script&lang=js"
import style0 from "./CiCampgroundInfo.vue?vue&type=style&index=0&id=15a36ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a36ac2",
  null
  
)

export default component.exports